import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, mergeProps as _mergeProps, vShow as _vShow, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "block w-full" }
const _hoisted_2 = { class: "flex mb-4" }
const _hoisted_3 = ["title"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "icon-neu" }, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = ["disabled", "title"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "icon-loeschen" }, null, -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "ml-auto" }
const _hoisted_10 = { class: "text-center" }

import {onBeforeUnmount, onMounted, reactive, ref} from "vue";
import {BryntumGrid} from "@bryntum/grid-vue-3";
import {Menu, Store} from "@bryntum/grid";
import GridInputFilter from "@/components/GridInputFilter.vue";
import {useGlobalStore} from "@/stores/GlobalStore";
import {ErrorLocationType, PopupType, TableType} from '@/utilities/enums/Enums';
import {$t} from "@/utilities/i18n/config";
import dialog from "@/dialog";
import ErrorHandler from "@/utilities/helpers/ErrorHandler";
import Error from "@/components/Error.vue";
import {useI18n} from "vue-i18n";
import {checkboxColumnConfig, defaultSpaceAroundTableOnPage} from "@/AppConfig";
import {ActivitySetInfo} from "@/models/activity/ActivitySetInfo";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import {ActivitySetService} from "@/utilities/services/entities/ActivitySetService";
import {ActivityService} from "@/utilities/services/entities/ActivityService";



export default /*#__PURE__*/_defineComponent({
  __name: 'ActivitySetTab',
  setup(__props) {

const gridStore = new Store();
const globalStore = useGlobalStore();

let selectedActivity = ref([]);
const activitySetService = new ActivitySetService();
const activityService = new ActivityService();

const deleteSelection = async() => {
  //drop call without selection
  if(!selectedActivity.value?.some(()=>true)) return;

  const answer = await dialog
      .okText(t("global.delete"))
      .cancelText(t("global.cancel"))
      .confirm(t("activitySet.confirmDeletionMulti", { count:selectedActivity.value.length}));

  if (answer) {
    let someEntriesFailed = false;
    for (const a of selectedActivity.value){
      const resp = await activitySetService.deleteActivitySet(a.id);

      if(resp === null || resp === undefined || resp?.statusCode !== 0){
        ErrorHandler.handleError(resp, ErrorLocationType.table);
        someEntriesFailed = true;
        continue;
      }

      gridStore.applyChangeset({removed:[{id:a.id}]});
    }

    if (someEntriesFailed) return;

    globalStore.showSuccess(t("global.deleted"));
  }
};

const currentWindowHeight = ref("");
const recalcGridHeight = () => {
  currentWindowHeight.value = `${window.innerHeight-defaultSpaceAroundTableOnPage-75}px`;
};

const grid = ref(null);
const { t } = useI18n();
const useGridConfig = {
  relayStoreEvents: true,
  headerMenuFeature: false,
  columns : {
    data: [
      { id: 'name', field: 'name', text: t('activitySet.grid.name'), flex: 1, },
      {
        id: 'activitySetLocationInfo',
        field: 'activitySetLocationInfo',
        text: '',
        width   : 36,
				sortable: false,
        type: 'template',
        template: ({ record }) => {
					if(record.data.activitySetLocationInfo.length > 0) {
						return `<div class='gridRowButton'><span class='icon-pin_outline'></span></div>`;
					} else {
						return ``;
					}
        },
      },
      {
        id: 'menu',
        text	: '',
        width   : 36,
        type	: 'widget',
        align: "center",
        hideable: false,
        resizable: false,
        sortable: false,
        filterable: false,
        widgets : [{
          type	 : 'button',
          width: 36,
          icon	 : 'icon-kontext_horizontal',
          onAction : ({ source: btn }) => {
            const menu = menuFactory(btn.cellInfo.record.data);
            menu.alignTo({ target: btn })
            menu.show();
          }
        }]
      },
    ],
    listeners:{
      async add(event:any){
        if(event.records.length === 1 && event.isMove[event.records[0].id]){
          await globalStore.saveUserColumnOrder(TableType[TableType.activitySet], event.records[0].id, event.index.toString());
        }
      },
    }
  },
  store: gridStore,
  enableTextSelection: true,
  selectionMode : {
    row	  : true,
    checkbox: checkboxColumnConfig,
    showCheckAll : true,
    deselectFilteredOutRecords: true,
  },
  listeners: {
    selectionChange(event) {
      if(event.selection.length > 0 && event.selection[0]?.data === undefined) return;
      selectedActivity.value = selectedActivity.value.concat(event.selected.map(ar => ar.data))
      selectedActivity.value = selectedActivity.value.filter(a => !event.deselected.map(ar => ar.data).some(ar => a?.id === ar?.id));
    },
    datachange(){
      globalStore.currentItems = gridStore.count;
      globalStore.allItems = gridStore.originalCount;
    },
    cellClick({column, record}) {
      if (column.data.field === 'activitySetLocationInfo' && record.data.activitySetLocationInfo.length > 0) {
        globalStore.openPopup({
          data: record.data,
          action: globalStore.closeModal,
          title: t('activitySet.grid.locations'),
          type: PopupType.activitySetLocationsPopup
        });
      }
    },
  },
  height: currentWindowHeight,
}

const menuFactory = (record:object) => {
  const menu = new Menu({
    anchor   : true,
    autoShow : true,
    items	: [
      {
        text: t("global.edit"),
        cls: 'color',
        icon: 'icon-editieren',
        weight: 100,
        onItem: ({ menu }) => {
          // flat copy current locations since refs keep same arrays
          const n = [];
          for (const l of menu.record.activitySetLocationInfo) n.push(l)
          tmpLocs = n;
          globalStore.openPopup({
            data: JSON.parse(JSON.stringify(menu.record)),
            action: addOrUpdateActivitySet,
            resetButton:false,
            title:$t("popups.activitySet.edit"),
            type:PopupType.activitySetEditPopup
          }, true);
        }
      },
      {
        text   : t("global.delete"),
        hidden: false,
        cls	: 'color',
        icon: 'icon-loeschen',
        weight : 140,
        onItem: async ({ menu }) => {
          const answer = await dialog
              .okText(t("global.delete"))
              .cancelText(t("global.cancel"))
              .confirm(t("activitySet.confirmDeletionSingle", {name: menu.record.name}));

          if (answer) {
            const resp = await activitySetService.deleteActivitySet(menu.record.id);

            if(resp === null || resp === undefined || resp?.statusCode !== 0){
              ErrorHandler.handleError(resp, ErrorLocationType.table);
              return;
            }

            gridStore.applyChangeset({removed:[{id:menu.record.id}]});

            globalStore.showSuccess(t('global.deleted'));
          }
        }
      }
    ],
  });

  menu.setRecord(record);

  return menu;
};


const gridConfig = reactive(useGridConfig);

const newActivitySet = () => {
  globalStore.openPopup({
    data: new ActivitySetInfo(),
    action: addOrUpdateActivitySet,
    resetButton: false,
    title: $t("popups.activitySet.new"),
    type: PopupType.activitySetEditPopup
  }, true);
}

let tmpLocs:Array<any> = [];
const computedAddedAndRemovedLocations = (newList:Array<any>)=>{
  const oldList = tmpLocs;

  const addedLocs = newList.filter(l => oldList.find(lo => lo.locationId === l.locationId) === undefined).map(l=>l.locationId);
  const removedLocs = oldList.filter(l => newList.find(lo => lo.locationId === l.locationId) === undefined).map(l=>l.locationId);

  return {added:addedLocs, removed:removedLocs}
}

const addOrUpdateActivitySet = async () => {
  const newActivitySet = globalStore.modal.contentObject as ActivitySetInfo;
  const addedAndRemovedLocations = computedAddedAndRemovedLocations(newActivitySet.activitySetLocationInfo)

  const resp = await activitySetService.addOrUpdateActivitySet(newActivitySet, addedAndRemovedLocations);
  if (resp === null || resp === undefined || resp.statusCode !== 0){
    ErrorHandler.handleError(resp, ErrorLocationType.popup);
    return;
  }

  if(newActivitySet.id < 0) newActivitySet.id = resp.id;
  // fix selection when it was an update -> replace old value in selected-array
  else if(selectedActivity.value.some(el => el.id === newActivitySet.id)) {
    selectedActivity.value = selectedActivity.value.filter(el => el.id !== newActivitySet.id);
    selectedActivity.value.push(newActivitySet);
  }

  gridStore.add(newActivitySet);
  gridStore.sort(gridStore.sorters);

  globalStore.closeModal();
  globalStore.showSuccess(t('global.saved'));
}

const setGridData = async () => {
  // start spinner
  globalStore.gridDataIsLoading = true;
  const activitySetResponse = await activitySetService.getActivitySets("display");

  if (activitySetResponse === null || activitySetResponse === undefined || activitySetResponse.statusCode !== 0) {
    ErrorHandler.handleError(activitySetResponse, ErrorLocationType.table);
    return;
  }

  const activitiesWithRenamedId = activitySetResponse.activitySetInfo.map(a => {a.id = a.activitySetId; return a;});

  // get ativities per activitySet
  for(const a of activitiesWithRenamedId){
    const activityResp = await activityService.getActivitySetActivities(a.id);

    if (activityResp === null || activityResp === undefined || activityResp.statusCode !== 0) {
      ErrorHandler.handleError(activityResp, ErrorLocationType.table);
      return;
    }

    a.activities = activityResp.activityInfo.map(ae => {
      ae.id = ae.activityId;
      ae.name = ae.activityText;
      return ae;
    });
  }

  gridStore.setStoreData(activitiesWithRenamedId);

  globalStore.reorderColumns(TableType[TableType.activitySet]);

  // stop spinner
  globalStore.gridDataIsLoading = false;
}

onMounted(async () => {
// calculate grid height and sub to window resize event
  recalcGridHeight();
  window.addEventListener('resize', recalcGridHeight);

  globalStore.setGridStore(ref(gridStore));
  globalStore.setGridColumnStore(ref(grid.value?.instance.value?.columns));

  await setGridData();
});

onBeforeUnmount(()=>{
  window.removeEventListener('resize', recalcGridHeight);

  globalStore.setGridStore(null);
  globalStore.setGridColumnStore(null);

  globalStore.currentItems = 0;
  globalStore.allItems = 0;
});

return (_ctx: any,_cache: any) => {
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("div", null, [
      _createVNode(Error, {
        errorLoc: _unref(ErrorLocationType).table
      }, null, 8, ["errorLoc"]),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("button", {
            class: "primary mr-2",
            onClick: newActivitySet,
            title: _unref(t)('activitySet.new')
          }, _hoisted_5, 8, _hoisted_3),
          _withDirectives((_openBlock(), _createElementBlock("button", {
            class: "primary mr-2",
            disabled: !_unref(selectedActivity).some(()=>true),
            onClick: deleteSelection,
            title: _unref(t)('global.delete')
          }, _hoisted_8, 8, _hoisted_6)), [
            [_directive_permission, 'ActivitySets.Show']
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(GridInputFilter, {
              gridStore: _unref(gridStore),
              hideFilterButton: true
            }, null, 8, ["gridStore"])
          ])
        ]),
        _createVNode(_unref(BryntumGrid), _mergeProps({
          ref_key: "grid",
          ref: grid
        }, gridConfig, { readOnly: true }), null, 16)
      ])
    ], 512), [
      [_vShow, !_unref(globalStore).gridDataIsLoading]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_10, [
      _createVNode(LoadingSpinner)
    ], 512), [
      [_vShow, _unref(globalStore).gridDataIsLoading]
    ])
  ], 64))
}
}

})